function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    
    this.relatedLineItem = this.closest('.cart-item') || null;
    this.IS_UPSELL_INPUT = this.relatedLineItem?.hasAttribute('data-upsell') || null;
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.inputEventMode = !this.hasAttribute('no-event');
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
    if(this.IS_UPSELL_INPUT) 
      this.updateLocalStorage('dw-added-upsells', 
        this.relatedLineItem.dataset.upsellId,
          this.relatedLineItem.dataset.upsellType, event.target.value);
  }

  updateLocalStorage(key, targetId, targetType, qty) {
    // Retrieve the existing data from localStorage
    let storedData = localStorage.getItem(key);
    
    if (storedData) {
        // Parse the stored JSON string to an object/array
        let dataArray = JSON.parse(storedData);
        
        // Find the object within the array that matches the targetId
        let targetObject = dataArray.find(item => item.lineItemId === Number(targetId));
        
        if (targetObject) {
            targetObject[targetType].amount = qty;

            localStorage.setItem(key, JSON.stringify(dataArray));
        } else {
            console.warn(`No item found with id: ${targetId}`);
        }
    } else {
        console.warn(`No data found for key: ${key}`);
    }
}


  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value && this.inputEventMode) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

// function debounce(fn, wait) {
//   let t;
//   return (...args) => {
//     clearTimeout(t);
//     t = setTimeout(() => fn.apply(this, args), wait);
//   };
// }

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}


class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      const cartItem = this.closest('.cart-item')

      cartItems.updateQuantity(this.dataset.index, 0);
      if(cartItem.hasAttribute('data-upsell')) 
      this.removeItemFromLocalStorage('dw-added-upsells', cartItem.dataset.upsellId, cartItem.dataset.upsellType);
    });
  }


  removeItemFromLocalStorage(key, itemID, itemType) {
    const localStorageItems = JSON.parse(localStorage.getItem(key)) || [];
    const targetItemIndex = localStorageItems.findIndex(item => item.lineItemId === Number(itemID));


        const targetItem = localStorageItems[targetItemIndex];
        if(targetItem == undefined) return false;

        targetItem[itemType].amount = 0;
        targetItem.hasSufficientUpsells = false;

        localStorageItems.splice(targetItemIndex, 1);
        localStorageItems.push(targetItem);

        localStorage.setItem(key, JSON.stringify(localStorageItems));
}

}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.cartData = null;
    this.cartItems = this.querySelectorAll('.cart-item');
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');


    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  updateShippingBars() {
    const shippingBars = document.querySelectorAll('.js-shipping-bar')
    shippingBars.forEach(shippingBar => updateBar(shippingBar))

    async function updateBar(bar) {
      try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const freeShippingThreshold = bar.getAttribute('threshold') || 100;
      const progressBar = bar.querySelector('.progress-bar__bar');
      const progressNumber = bar.querySelector('.progress-bar__message b');


        const cartCurrency = new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: 'GBP'
        });
        const subtotal = cart.total_price;
        const progress = Math.min(subtotal / freeShippingThreshold, 1); // Calculate the progress towards free shipping
        const progressPercent = Math.round(progress * 100); // Calculate the progress percentage
        const currentTarget = window.formatMoney((freeShippingThreshold - subtotal), '£{{amount}}');

        progressBar.style = `--progress:${progressPercent}%;`; // Update the width of the progress bar element
        progressBar.setAttribute('aria-valuenow', progressPercent); // Set the progress percentage as the ARIA value
  
        if (subtotal >= freeShippingThreshold) {
          bar.setAttribute('filled', '');
        } else {
          bar.removeAttribute('filled');
        }

        progressNumber.innerHTML = currentTarget;
      } catch (error) {
        console.log("Error fetching cart data from Shopify Cart API:", error);
      }
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }


  handleDatePickerButton(cartData){
    const datePickerButton = document.querySelector('.cart__ctas #datePickerButton');
    if(!datePickerButton) return;
    if(cartData.total_price > 0){
      datePickerButton.style.display = 'inline-flex';
    } else {
      datePickerButton.style.display = 'none';
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-header',
        section: document.getElementById('cart-header').dataset.id,
        selector: '.js-sample-count',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents-2',
      }
    ];
  }

  updateHeaderIcon(itemCount){
    const countBubble = document.querySelector('.header-icons-cart-snippet .cart-count-badge');
    if(!countBubble) return;
    countBubble.innerHTML = itemCount;
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          console.log(parsedState.errors)
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartItemsHeader = this.querySelector('.cart__header');
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');
        const cartFooterWrapper = document.querySelector('.cart__footer-wrapper');

        if (cartItemsHeader) cartItemsHeader.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartFooterWrapper) cartFooterWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.updateShippingBars();
        this.renderSections(parsedState);

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        
        this.updateLiveRegions(line, message);

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  renderSections(parsedState) {
    this.updateHeaderIcon(parsedState.item_count);
    this.handleDatePickerButton(parsedState);
    this.getSectionsToRender().forEach((section) => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      elementToReplace.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.section],
        section.selector
      );
    });
    window.dispatchEvent(new CustomEvent('cartChangeEvent'));
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError && message !== "") {
      lineItemError.classList.remove('hide')
      lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
    }

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

